package one.devsbox.www.ui.uploader

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.globalViewModel

class UploaderCtx private constructor(
    val vm: UploaderVM,
    val nav: Navigation,
    val args: UploaderArgs
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): UploaderCtx {
            val nav = LocalNavigation.current
            val vm = globalViewModel(UploaderVM::class)
            val args = LocalNavigationArgs.current.args(UploaderArgs::class)
            return remember {
                UploaderCtx(vm, nav, args).apply {
                    vm.setup(this)
                }
            }
        }
    }
}
